import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Checkbox from "@material-ui/core/Checkbox";
import { useConfigurationData } from "../utils/ConfigurationComponentUtils";
import { HtmlString } from "../../Utils";

/**
 * Configuration component for a boolean value.
 * @param path - configuration path which uniquely identifies the configuration value bound to this component
 * @param component - optional component used to render the checked/boolean value; defaults to Checkbox.
 */
var ConfigurationCheckBox = function ConfigurationCheckBox(_ref) {
  var path = _ref.path,
    component = _ref.component,
    handleChanged = _ref.handleChanged,
    labelProps = _ref.labelProps;
  var _useConfigurationData = useConfigurationData(path),
    _useConfigurationData2 = _slicedToArray(_useConfigurationData, 2),
    data = _useConfigurationData2[0],
    setData = _useConfigurationData2[1];
  var ToggleComponent = component ? component : Checkbox;
  var onChange = function onChange(event) {
    var newData = _objectSpread({}, data);
    newData.value = event.target.checked + "";
    setData(newData);
    if (handleChanged) {
      handleChanged(newData.value);
    }
  };
  return /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, Object.assign({
    control: /*#__PURE__*/React.createElement(ToggleComponent, {
      color: "primary"
      // Ensure that both Boolean and String comparisons work
      ,
      checked: String(data.value) === "true",
      onChange: onChange
    }),
    name: data.id,
    label: data.label
  }, labelProps))), /*#__PURE__*/React.createElement(FormHelperText, null, /*#__PURE__*/React.createElement(HtmlString, {
    text: data.description
  })));
};
export default ConfigurationCheckBox;